import Avatar from '@mui/material/Avatar';

function InitialsCircle({
  userName,
  size = 45,
  className,
}: {
  userName: string;
  size?: number;
  className?: string;
}) {
  const getInitials = (name: string) => {
    const parts = name
      .trim()
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .split(' ');
    if (parts.length > 1) {
      return parts
        .slice(0, 2)
        .map((part) => part[0])
        .join('')
        .toUpperCase();
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  };

  // Updated to generate more vivid colors
  const strToHslColor = (str: string, saturation = 50, lightness = 65) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360; // Hue derived from name
    return `hsl(${h}, ${saturation}%, ${lightness}%)`;
  };

  let initials = userName ? getInitials(userName) : '';
  let hasValidInitials = initials.length > 0;

  return (
    <Avatar
      sx={{
        bgcolor: strToHslColor(userName), // Use updated strToHslColor
        border: '.5px solid white',
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size / 2}px`,
      }}
      className={className}
      alt={hasValidInitials ? userName : 'User'}
      src={hasValidInitials ? undefined : '/broken-image.jpg'}
    >
      {initials} {/* Fallback to 'U' if no initials */}
    </Avatar>
  );
}

export default InitialsCircle;
